module.exports = __webpack_public_path__ + "static/013-b9e8fcca600245e4ec6a45b2a30f8075.jpg";